import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { url } from "./config.js";

import Home from "./Home";
import Product from "./Product";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Cart from "./Cart";
import LogIn from "./LogIn";
import Register from "./Register";
import UserPage from "./UserPage";
import Billing from "./BillingInfo";
import Payment from "./Payment";
import Sale from "./Sale";
import ContactUs from "./ContactUs.js";
import ConfirmOrder from "./ConfirmOrder.js";

import ProductList from "./admin/productList";
import EditingProducts from "./admin/editingProducts.js";
import CreateProduct from "./admin/createProduct.js";
import OrderList from "./admin/orderList.js";

import "./App.css";
import Axios from "axios";

function App() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryTitle, setCategoryTitle] = useState("All Products");
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    checkUser();
  });

  const logOut = () => {
    sessionStorage.removeItem("token");
    setLoggedIn(false);
  };
  const checkUser = async () => {
    try {
      const token = JSON.parse(sessionStorage.getItem("token"));
      if (token !== null) {
        const response = await Axios.post(`${url}/users/verify_token`, {
          token
        });
        response.data.ok ? setLoggedIn(true) : logOut();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCategories = async () => {
    try {
      const categories = await Axios.get(`${url}/category/display`);
      setCategories(categories.data.allCategories);
    } catch (error) {
      console.log(error);
    }
  };

  const getProductsByCategoryId = async (_id, category) => {
    try {
      const cateProducts = await Axios.get(
        `${url}/products/getbycategory/${_id}`
      );
      setProducts(cateProducts.data.category);
      setCategoryTitle(category);
    } catch (error) {
      console.log(error);
    }
  };

  const getProducts = async () => {
    try {
      const products = await Axios.get(`${url}/products/display`);
      setProducts(products.data.allProducts);
    } catch (error) {
      console.log("error = ", error);
    }
  };

  const sortProducts = async order => {
    try {
      const sort = await Axios.get(`${url}/products/sort/${order}`);
      setProducts(sort.data.allProducts);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemove = async _id => {
    try {
      await Axios.post(`${url}/products/remove`, { _id });
      getProducts();
    } catch (error) {
      console.log(error);
    }
  };

  const search = async e => {
    try {
      const response = await Axios.get(
        `${url}/products/search/${e.target.value}`
      );
      setProducts(response.data.products);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Router>
      <Header loggedIn={loggedIn} logOut={logOut} />
      <Navbar
        categories={categories}
        getProductsByCategoryId={getProductsByCategoryId}
        search={search}
      />
      <Route
        exact
        path={"/kim-commerce"}
        render={props => {
          return (
            <Home
              {...props}
              products={products}
              categoryTitle={categoryTitle}
              sortProducts={sortProducts}
            />
          );
        }}
      />
      <Route exact path={'/'}><Redirect to={'/kim-commerce'}/></Route>
      <Route path={"/kim-commerce/product/:product"} component={Product} />
      <Route path={"/kim-commerce/contactus"} component={ContactUs} />
      <Route path={"/kim-commerce/cart"} component={Cart} />
      <Route
        path={"/kim-commerce/login"}
        render={props => {
          return <LogIn {...props} checkUser={checkUser} />;
        }}
      />
      <Route path={"/kim-commerce/register"} component={Register} />
      <Route path={"/kim-commerce/userpage"} component={UserPage} />
      <Route path={"/kim-commerce/billing"} component={Billing} />
      <Route path={"/kim-commerce/payment"} component={Payment} />
      <Route path={"/kim-commerce/confirmorder"} component={ConfirmOrder} />
      <Route
        path={"/kim-commerce/admin/productlist"}
        render={props => {
          return (
            <ProductList
              {...props}
              products={products}
              handleRemove={handleRemove}
            />
          );
        }}
      />
      <Route
        path={"/kim-commerce/admin/createproduct"}
        render={props => {
          return <CreateProduct {...props} getProducts={getProducts} />;
        }}
      />
      <Route
        path={"/kim-commerce/admin/edit/:_id"}
        render={props => {
          return <EditingProducts {...props} getProducts={getProducts} />;
        }}
      />
      <Route path={"/kim-commerce/admin/orderlist"} component={OrderList} />
      <Route
        path={"/kim-commerce/sale"}
        render={props => {
          return <Sale {...props} products={products} />;
        }}
      />

      <Footer />
    </Router>
  );
}

export default App;
